var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-lines"},[_c('div',{staticClass:"loading-line"}),_c('div',{staticClass:"loading-line report-line-2"})])
}]

export { render, staticRenderFns }